import React from "react";
import { Row, Col, Table, Badge, Button } from "react-bootstrap";
import CreateReceiptModal from "../Accounts/Receipt.jsx";
import {
  getAccountByPatientId,
  getPatientIdByMedAidDepCode,
  checkAccountByMedicalAid,
} from "../../api.js";
import "./UnallocatedERA.css";
import { useNavigate } from "react-router-dom";

export default function UnallocatedERA({ eraUnallocated = [] }) {
  const [receiptModalShow, setReceiptModalShow] = React.useState(false);
  const [patientId, setPatientId] = React.useState(null);
  const [account, setAccount] = React.useState(null);
  const navigate = useNavigate();

  if (!Array.isArray(eraUnallocated) || eraUnallocated.length === 0) {
    return (
      <p className="text-muted fst-italic small ms-2 mt-2">
        No unmatched ERA transactions found.
      </p>
    );
  }

  const formatCurrency = (x) =>
    x || x === 0
      ? new Intl.NumberFormat("en-ZA", {
          style: "currency",
          currency: "ZAR",
          minimumFractionDigits: 2,
        }).format(x)
      : "";

const handleGoToAccount = async (item) => {
  try {
    const accountData = await checkAccountByMedicalAid(item.accountMedicalAidNumber);
    console.log(accountData)
    if (accountData && accountData._id) {
      // Assuming you have a function to navigate to the account page
      navigate(`/accounts/${accountData._id}`);
    } else {
      console.warn("No account found for medical aid number:", item.accountMedicalAidNumber);
      alert("No account found for the specified medical aid number.");
    }
  } catch (error) {
    console.error("Error navigating to account:", error);
    alert("An error occurred while navigating to the account. Please try again later.");
  }
}      

const handleAllocate = async (item) => {
  try {
    const patientId = await getPatientIdByMedAidDepCode(
      item.accountMedicalAidNumber,
      item.dependantCode
    );

    if (!patientId) {
      console.warn("No patient found for:", item.accountMedicalAidNumber, item.dependantCode);
      alert("No patient found for the specified medical aid and dependant code.");
      return;
    }

    setPatientId(patientId);

    const account = await getAccountByPatientId(patientId);

    if (!account) {
      console.warn("No account found for patient:", patientId);
      alert("No account found for the selected patient.");
      return;
    }

    setAccount(account);
    setReceiptModalShow(true);

    console.log("Fetched patient ID:", patientId);
    console.log("Fetched account:", account);
  } catch (error) {
    console.error("Error allocating item:", error);
    alert("An error occurred while allocating the item. Please try again later.");

    setPatientId(null);
    setAccount(null);
    setReceiptModalShow(false);
  }
};

      // Fetch patient ID using medical aid and dependant code

  return (
    <div className="mt-1 unallocated-era">
      {eraUnallocated.map((item, idx) => {
        // ✅ Determine if any line has a paidAmount > 0
        const hasPaidAmount =
          Array.isArray(item.lines) &&
          item.lines.some((line) => Number(line.paidAmount) > 0);

        return (
          <div
            key={idx}
            className="p-1 mb-3 bg-white pb-2 border-bottom border-secondary"
            style={{ fontSize: "0.9rem" }}
          >
            {/* ---- Claim Header ---- */}
            <Row className="mb-2 align-items-center">
              {/* Patient */}
              <Col md={3}>
                <span className="text-primary fw-semibold fs-6">Patient:</span>{" "}
                {item.patientName || "-"}
              </Col>

              {/* Medical Aid # */}
              <Col md={3}>
                <span className="text-primary fw-semibold fs-6">
                  Medical Aid #:
                </span>{" "}
                {item.accountMedicalAidNumber || "-"}({item.dependantCode || "-"})
              </Col>

              {/* Treatment Date */}
              <Col md={2}>
                <span className="text-primary fw-semibold fs-6">
                  Treatment:
                </span>{" "}
                {item.treatmentDate
                  ? new Date(item.treatmentDate).toLocaleDateString()
                  : "-"}
              </Col>

              {/* Transaction # */}
              <Col md={2}>
                <span className="text-primary fw-semibold fs-6">Trans #:</span>{" "}
                {item.transactionNumber || "-"}
              </Col>

              {/* Allocate button */}
              {hasPaidAmount && (
                <Col md={2} className="text-end">
                  <Button
                    variant="primary"
                    size="sm"
                    className="fw-semibold shadow-sm"
                    onClick={() => handleAllocate(item)}
                  >
                    <i className="fa-solid fa-receipt me-2"></i>Allocate
                  </Button>
                </Col>
              )}
              {!hasPaidAmount && (
              <Col md={2} className="text-end">
               <Button
                    variant="primary"
                    size="sm"
                    className="fw-semibold shadow-sm"
                    onClick={() => handleGoToAccount(item)}
                  >
                    Account<i className="fa-solid fa-arrow-right ms-2"></i>
                  </Button>
              </Col>
              )}
            </Row>

            {/* ---- Line Items Table ---- */}
            {Array.isArray(item.lines) && item.lines.length > 0 ? (
              <Table
                bordered
                hover
                size="sm"
                responsive
                className="mb-2 align-middle"
              >
                <thead className="table-light text-center">
                  <tr>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "5%" }}
                    >
                      Line #
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "10%" }}
                    >
                      Date of Service
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "10%" }}
                    >
                      Tariff Code
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "10%" }}
                    >
                      Claimed
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "10%" }}
                    >
                      Paid
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "10%" }}
                    >
                      Patient Portion
                    </th>
                    <th
                      className="text-primary fw-semibold"
                      style={{ width: "45%" }}
                    >
                      Reason Codes
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item.lines.map((line, i) => (
                    <tr key={i}>
                      <td className="text-center fs-sm">
                        {line.eraLineNumber}
                      </td>
                      <td className="text-center fs-sm">
                        {line.dateOfService
                          ? new Date(line.dateOfService).toLocaleDateString()
                          : "-"}
                      </td>
                      <td className="text-center">{line.tariffCode || "-"}</td>
                      <td className="text-center">
                        {formatCurrency(line.claimedAmount || 0)}
                      </td>
                      <td className="text-center">
                        {formatCurrency(line.paidAmount || 0)}
                      </td>
                      <td className="text-center">
                        {formatCurrency(line.patientPortion || 0)}
                      </td>
                      <td className="text-start">
                        {Array.isArray(line.reasonCodes) &&
                        line.reasonCodes.length > 0 ? (
                          line.reasonCodes.map((r, k) => (
                            <div key={k} className="small">
                              <Badge
                                bg="warning"
                                text="dark"
                                className="me-2 fw-semibold"
                              >
                                {r.code}
                              </Badge>
                              {r.description}
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="text-muted small mb-0">
                No lines recorded for this claim.
              </p>
            )}
          </div>
        );
      })}
      {receiptModalShow && (
        <CreateReceiptModal
          show={receiptModalShow}
          onHide={() => setReceiptModalShow(false)}
          patient={patientId}
          account={account}
        />
      )}
    </div>
  );
}
